export default __webpack_public_path__ + "static/media/portfolio-smiles-3.f8de5de5.jpg";